var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customize_your_interface{padding-top:40px;padding-bottom:80px}#intro_keybindings{width:640px;height:424px;background:url(" + escape(require("../assets/images/intro_keybindings.png")) + ") no-repeat;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-078b0b21","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CustomizeYourInterface.vue
// module id = 74
// module chunks = 0